import { ApiResourcePaths } from "../../../apiRoutes";
import { UpdateGroupDto } from "../../../models/domain/UpdateGroupDto";
import { ApiResourceTableProps } from "../../../comps/api-resource-table/ApiResourceTable";
import { UpdateGroupFarmDto } from "../../../models/domain/UpdateGroupFarmDto";
import { IdExtraParams, useApiClient } from "../../../hooks/useApiClient";
import { useApiResourceTable } from "../../../hooks/useApiResourceTable";
import { UpdateGroupAssignedFarmsColumnsFactory } from "./UpdateGroupAssignedFarmsColumnsFactory";
import { NoRefetchQueryOptions } from "../../../comps/api-resource-table/ApiResourceTableDefaults";
import { useEffect, useState } from "react";
import { PageInfoDto } from "../../../models/domain/pagination/PageInfoDto";
import { useDataShaper } from "../../../core/table/useDataShaper";
import { UpdateGroupFarmConfig } from "./UpdateGroupFarmConfig";
import { getShapingFromTable } from "../../../core/table/GetShapingFromTable";
import { getShapedData } from "../../../core/table/GetShapedData";

export const useUpdateGroupAssignedFarmsProfile =
  (updateGroup: UpdateGroupDto | undefined): ApiResourceTableProps<UpdateGroupFarmDto> => {
    const apiClient = useApiClient();
    const [overrideData, setOverrideData] = useState<PageInfoDto<UpdateGroupFarmDto>>();

    const table = useApiResourceTable<UpdateGroupFarmDto, IdExtraParams>({
      requestFn: apiClient.updateGroup.farm.listAssigned,
      queryExtraParams: () => ({id: !!updateGroup?.id ? updateGroup.id : 0}),
      queryKeyFn: () => ApiResourcePaths.updateGroupAssignedFarms(null, updateGroup?.id),
      columnFactory: UpdateGroupAssignedFarmsColumnsFactory(updateGroup),
      queryOptions: {
        ...NoRefetchQueryOptions,
        enabled: !!updateGroup?.id,
        placeholderData: prev => prev,
      },
      mrtParams: {
        initialSorting: [{id: "updateGroupId", desc: true}]
      }
    });

    const shaper = useDataShaper(UpdateGroupFarmConfig, getShapingFromTable(table))

    const { data } = table.query;

    useEffect(() => setOverrideData(getShapedData(data, shaper)),
      [data, setOverrideData, shaper]);

    return {
      ...table,
      overrideData,
      tableProps: {
        state: {
          density: "compact"
        },
        manualSorting: true,
        manualFiltering: true,
        manualPagination: true,
      }
    };
  }